import { defineComponent as _defineComponent } from 'vue'
import { PropType } from 'vue'
import { adicionarBuscaRecente } from '@/shareds/buscasRecentes'
import { ResultadoBusca, ResultadoIrmao } from '../../../../common/types/Busca'
import { useRouter } from '@/composables/router'


export default /*#__PURE__*/_defineComponent({
  __name: 'ItemIrmao',
  props: {
	item: { type: Object as PropType<ResultadoIrmao>, required: true },
},
  setup(__props) {

const props = __props;



const router = useRouter()

function onClickItemBusca() {
	adicionarBuscaRecente(props.item satisfies ResultadoBusca)
	router.push({
		name: 'detalhar-irmao',
		params: { id: props.item._id },
	})
}

return { __sfc: true,props, router, onClickItemBusca }
}

})